import { doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import { fireStore } from "../../firebase";
import { useAppSelector } from "../storeHooks";
export const useOnUpdateQuotes = (
  shouldStartUpdating: boolean,
  callback: () => void,
  eventId: string
) => {
  const [quotesUpdated, setQuotesUpdated] = useState<Timestamp | null>(null);
  const event = useAppSelector((state) => state.events.event);

  useEffect(() => {
    let unsubscribe: () => void;
    if (fireStore && eventId && event?.id && shouldStartUpdating) {
      const documentRef = doc(fireStore, "events", eventId);
      unsubscribe = onSnapshot(documentRef, (doc) => {
        if (doc.exists()) {
          setQuotesUpdated(doc.data().quotesUpdated);
        }
      });
    }
    return () => unsubscribe && unsubscribe();
  }, [shouldStartUpdating, eventId, event?.id]);

  useEffect(() => {
    if (quotesUpdated && shouldStartUpdating) {
      callback();
    }
  }, [quotesUpdated, shouldStartUpdating, callback]);
};
